/* istanbul ignore file */
import { useCrudService } from 'framework/crud';
import { useKernelApi, useBusinessEngineApi } from 'infrastructure/api';
import oneStopBudgetReallocationValidation from './oneStopBudgetReallocationValidation';

const BUDGET_REALLOCATION_PATH = '/budgetReallocations';

const useBudgetReallocationService = () => {
  const singleResourceUrl = `${BUDGET_REALLOCATION_PATH}/:id`;
  const { ...baseCrudRequests } = useCrudService({
    singleResourceUrl,
    listResourceUrl: BUDGET_REALLOCATION_PATH,
    useService: useKernelApi,
  });

  const getOneStopValidationSchema = () => Promise.resolve(oneStopBudgetReallocationValidation);

  const { sendPostRequest } = useBusinessEngineApi();

  const createBudgetReallocation = async (budgetReallocation: any) => {
    const response = await sendPostRequest(BUDGET_REALLOCATION_PATH, budgetReallocation);
    return response.json();
  };

  return {
    getOneStopValidationSchema,
    ...baseCrudRequests,
    createBudgetReallocation,
  };
};

export default useBudgetReallocationService;
